module.exports = __webpack_public_path__ + "img/htsy1.54ee0b41.png";